import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.75rem;
`;
export default function Radon() {
  return (
    <Wrapper width="32" height="32" viewBox="0 0 32 32">
      <path
        d="M31.5563 14.9715L28.6472 12.0624L17.0107 0.425875C16.7379 0.153188 16.368 0 15.9823 0C15.5966 0 15.2267 0.153188 14.9539 0.425875L3.31743 12.0624L0.408312 14.9715C0.143352 15.2458 -0.00325911 15.6132 5.49862e-05 15.9946C0.00336909 16.376 0.156344 16.7408 0.426031 17.0105C0.695718 17.2802 1.06054 17.4332 1.44192 17.4365C1.8233 17.4398 2.19073 17.2932 2.46506 17.0282L2.89125 16.602V30.5454C2.89125 30.9312 3.0445 31.3012 3.31728 31.574C3.59006 31.8468 3.96003 32 4.34581 32H27.6188C28.0046 32 28.3745 31.8468 28.6473 31.574C28.9201 31.3012 29.0733 30.9312 29.0733 30.5454V16.602L29.4995 17.0282C29.7739 17.2932 30.1413 17.4398 30.5227 17.4365C30.904 17.4332 31.2689 17.2802 31.5386 17.0105C31.8082 16.7408 31.9612 16.376 31.9645 15.9946C31.9678 15.6132 31.8212 15.2458 31.5563 14.9715ZM26.1642 29.0909H5.80037V13.6929L15.9823 3.511L26.1642 13.6929V29.0909Z"
        className="fill"
      />
      <rect
        x="8.18359"
        y="23.7988"
        width="15.5978"
        height="2.97102"
        rx="1.45617"
        className="fill"
      />
      <rect
        x="8.18359"
        y="18.5991"
        width="15.5978"
        height="2.97101"
        rx="1.45617"
        className="fill"
      />
      <rect
        x="8.18359"
        y="13.4004"
        width="15.5978"
        height="2.97101"
        rx="1.45617"
        className="fill"
      />
    </Wrapper>
  );
}
